import {
  LegalClientEntity,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import { LoadingLayout } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  BackBody,
  OnboardingLayout,
} from 'modules/onboarding/common/components';
import { OnboardingProvider } from 'modules/onboarding/common/providers';

import { useOnboarding } from '../hooks/useOnboarding';
import { pagesMap } from '../route';

interface Props {
  currentClient: LegalClientRepresentativeEntity;
  legalClient: LegalClientEntity;
  legalHeadId: string;
  id?: string;
  goBack: () => void;
  onCreateFirstHead: (id: string) => void;
}

export const LegalClientLegalHeadFirstHeadContainer = ({
  id,
  currentClient,
  legalClient,
  legalHeadId,
  goBack,
  onCreateFirstHead,
}: Props) => {
  const { loading, firstHead, process, getFirstHead, onEnd, onGoBack } =
    useOnboarding(currentClient, legalClient, legalHeadId, id);

  const { t } = useTranslation();

  if (loading) {
    return <LoadingLayout />;
  }

  const handleEnd = async () => {
    if (await onEnd()) {
      goBack();
    }
  };

  const handleCreateFirstHead = async (id: string) => {
    await getFirstHead(legalClient.id, legalHeadId, id);
    onCreateFirstHead(id);
  };

  return (
    <OnboardingProvider
      clientId={currentClient.id}
      data={{
        currentClient,
        legalClient,
        legalHeadId,
        firstHead,
        onCreateFirstHead: handleCreateFirstHead,
      }}
      pagesMap={pagesMap}
      process={firstHead?.onboarding?.process ?? process!}
      renderChild={({ route }) => {
        const Component = route.page.component;
        return (
          <OnboardingLayout key={route.pageKey} headerComponent={<div />}>
            <Stack spacing={16}>
              <BackBody
                text={t('onboarding.legalClientFirstHead.backTitle')}
                onClick={goBack}
              />
              <Component {...route.page.componentProps} />
            </Stack>
          </OnboardingLayout>
        );
      }}
      onEnd={handleEnd}
      onGoBack={onGoBack}
    />
  );
};
